

import React, { useState, useEffect } from "react";
import Sidebar from "../../Components/Sidebar";
import TopNav from "../../Components/TopNav";
import {
  getBlogListServ,
  deleteBlogServ,
} from "../../services/blog.service";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import NoRecordFound from "../../Components/NoRecordFound";
import { IMAGE_BASE_URL } from "../../utils/api_base_url_configration";


/* ─── Scoped styles — same design language as OrderList ─── */
const styles = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=DM+Mono:wght@500&display=swap');

  .bl-page {
    background: #f5f5f7;
    min-height: 100%;
    padding: 28px;
    font-family: 'DM Sans', 'Segoe UI', sans-serif;
  }

  /* ── Stat Grid ── */
  .bl-stat-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 14px;
    margin-bottom: 22px;
  }
  @media (max-width: 900px)  { .bl-stat-grid { grid-template-columns: repeat(2, 1fr); } }
  @media (max-width: 600px)  { .bl-stat-grid { grid-template-columns: 1fr; } }

  .bl-stat-card {
    background: #fff;
    border-radius: 14px;
    padding: 18px 20px;
    border: 1px solid #f0eded;
    display: flex;
    align-items: center;
    gap: 16px;
    transition: box-shadow 0.18s, transform 0.18s;
  }
  .bl-stat-card:hover {
    box-shadow: 0 6px 24px rgba(192,57,43,0.09);
    transform: translateY(-2px);
  }
  .bl-stat-icon {
    width: 46px;
    height: 46px;
    border-radius: 12px;
    background: #fdf2f1;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    color: #a60808;
    flex-shrink: 0;
  }
  .bl-stat-val {
    font-size: 26px;
    font-weight: 700;
    color: #1c0a0a;
    line-height: 1;
    letter-spacing: -0.5px;
  }
  .bl-stat-lbl {
    font-size: 12.5px;
    color: #9a9a9a;
    margin-top: 5px;
    font-weight: 500;
    letter-spacing: 0.2px;
  }

  /* ── Toolbar ── */
  .bl-toolbar {
    background: #fff;
    border-radius: 14px;
    padding: 16px 20px;
    border: 1px solid #f0eded;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 16px;
  }
  .bl-toolbar-title {
    font-size: 18px;
    font-weight: 700;
    color: #1c0a0a;
    letter-spacing: -0.3px;
  }
  .bl-toolbar-right {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
  }

  /* Search input */
  .bl-search-wrap {
    position: relative;
    display: flex;
    align-items: center;
  }
  .bl-search-icon {
    position: absolute;
    left: 11px;
    color: #bbb;
    font-size: 15px;
    pointer-events: none;
  }
  .bl-search {
    height: 40px;
    border-radius: 10px;
    border: 1px solid #f0eded;
    padding: 0 14px 0 34px;
    font-size: 13px;
    color: #444;
    background: #f9f9f9;
    outline: none;
    width: 210px;
    font-family: 'DM Sans', sans-serif;
    transition: border-color 0.15s, background 0.15s;
  }
  .bl-search:focus {
    border-color: #f0c0b8;
    background: #fff;
  }
  .bl-search::placeholder { color: #bbb; }

  .bl-select {
    height: 40px;
    border-radius: 10px;
    border: 1px solid #f0eded;
    padding: 0 14px;
    font-size: 13px;
    color: #555;
    background: #f9f9f9;
    outline: none;
    cursor: pointer;
    font-family: 'DM Sans', sans-serif;
    transition: border-color 0.15s;
  }
  .bl-select:focus { border-color: #f0c0b8; }

  .bl-btn-red {
    height: 40px;
    padding: 0 20px;
    border-radius: 10px;
    background: #a60808;
    color: #fff;
    border: none;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 7px;
    white-space: nowrap;
    font-family: 'DM Sans', sans-serif;
    letter-spacing: 0.2px;
    transition: background 0.18s, transform 0.1s;
  }
  .bl-btn-red:hover { background: #a93226; transform: translateY(-1px); }
  .bl-btn-red:active { transform: translateY(0); }

  /* ── Table ── */
  .bl-table-wrap {
    background: #fff;
    border-radius: 14px;
    border: 1px solid #f0eded;
    overflow: hidden;
  }
  .bl-table-scroll { overflow-x: auto; }
  .bl-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13.5px;
    font-family: 'DM Sans', sans-serif;
  }
  .bl-table thead tr { background: #fdf2f1; }
  .bl-table th {
    padding: 14px 18px;
    text-align: left;
    font-size: 11px;
    font-weight: 700;
    color: #a60808;
    text-transform: uppercase;
    letter-spacing: 0.8px;
    white-space: nowrap;
  }
  .bl-table td {
    padding: 14px 18px;
    color: #444;
    border-top: 1px solid #f7f5f5;
    vertical-align: middle;
  }
  .bl-table tbody tr { transition: background 0.12s; }
  .bl-table tbody tr:hover td { background: #fdfafa; }

  /* Sr no */
  .bl-sr {
    font-size: 12px;
    color: #aaa;
    font-family: 'DM Mono', monospace;
    font-weight: 500;
  }

  /* Banner image */
  .bl-banner {
    width: 48px;
    height: 48px;
    border-radius: 10px;
    object-fit: cover;
    border: 1px solid #f0eded;
    display: block;
  }
  .bl-banner-placeholder {
    width: 48px;
    height: 48px;
    border-radius: 10px;
    background: #fdf2f1;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #e0b0ac;
    font-size: 20px;
    border: 1px dashed #f0c0b8;
  }

  /* Title cell */
  .bl-title-text {
    font-size: 13.5px;
    font-weight: 600;
    color: #1c0a0a;
    max-width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  /* Tags */
  .bl-tag {
    display: inline-block;
    background: #fdf2f1;
    color: #a60808;
    border-radius: 6px;
    padding: 3px 9px;
    font-size: 11.5px;
    font-weight: 600;
    letter-spacing: 0.2px;
  }

  /* Rank */
  .bl-rank {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    background: #f5f5f7;
    font-size: 13px;
    font-weight: 700;
    color: #555;
    font-family: 'DM Mono', monospace;
  }

  /* Status badge */
  .bl-badge {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 5px 12px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.2px;
  }
  .bl-badge.active {
    background: #eafaf1;
    color: #1e8449;
  }
  .bl-badge.inactive {
    background: #fef9ec;
    color: #b7770d;
  }
  .bl-badge-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
  }
  .bl-badge.active .bl-badge-dot  { background: #27ae60; }
  .bl-badge.inactive .bl-badge-dot { background: #f39c12; }

  /* Date */
  .bl-date {
    font-size: 13px;
    color: #555;
    font-family: 'DM Mono', monospace;
    font-weight: 500;
  }

  /* Action buttons */
  .bl-edit-btn {
    height: 34px;
    padding: 0 16px;
    border-radius: 9px;
    background: #1c0a0a;
    color: #fff;
    border: none;
    font-size: 12.5px;
    font-weight: 600;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 5px;
    transition: background 0.18s, transform 0.1s;
    font-family: 'DM Sans', sans-serif;
    margin-right: 6px;
  }
  .bl-edit-btn:hover { background: #a60808; transform: translateY(-1px); }

  .bl-del-btn {
    height: 34px;
    padding: 0 14px;
    border-radius: 9px;
    border: 1px solid #f0eded;
    background: #fff;
    font-size: 12.5px;
    font-weight: 600;
    color: #a60808;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 5px;
    transition: all 0.18s;
    font-family: 'DM Sans', sans-serif;
  }
  .bl-del-btn:hover {
    background: #fdf2f1;
    border-color: #f0c0b8;
    transform: translateY(-1px);
  }

  /* ── Pagination ── */
  .bl-pagination {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
    padding: 16px 20px;
    border-top: 1px solid #f7f5f5;
  }
  .bl-show-row {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    color: #888;
    font-family: 'DM Sans', sans-serif;
  }
  .bl-page-btns { display: flex; align-items: center; gap: 5px; }
  .bl-pg-btn {
    width: 34px;
    height: 34px;
    border-radius: 9px;
    border: 1px solid #f0eded;
    background: #fff;
    font-size: 13px;
    color: #555;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'DM Sans', sans-serif;
    font-weight: 500;
    transition: all 0.18s;
  }
  .bl-pg-btn.active  { background: #a60808; color: #fff; border-color: #a60808; }
  .bl-pg-btn:hover:not(.active):not(:disabled) { background: #fdf2f1; color: #a60808; }
  .bl-pg-btn:disabled { opacity: 0.35; cursor: default; }

  /* Skeleton */
  .bl-skel-cell { padding: 14px 18px; border-top: 1px solid #f7f5f5; }

  /* Empty state */
  .bl-empty {
    text-align: center;
    padding: 52px 20px;
  }
  .bl-empty-icon {
    font-size: 40px;
    color: #f0c0b8;
    margin-bottom: 12px;
  }
  .bl-empty-text {
    font-size: 14px;
    color: #aaa;
    font-weight: 500;
    font-family: 'DM Sans', sans-serif;
  }
`;

const STAT_ICONS = ["ti-article", "ti-circle-check", "ti-circle-x"];

function BlogList() {

   const getImageUrl = (image) => {
  if (!image) return "";

  // Already full URL (Cloudinary etc.)
  if (image.startsWith("http")) return image;

  // Local uploads
  return `${IMAGE_BASE_URL}${image}`;
};

  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [statics, setStatics] = useState(null);
  const [payload, setPayload] = useState({
    searchKey: "",
    status: "",
    pageNo: 1,
    pageCount: 10,
    sortByField: "",
  });
  const [showSkelton, setShowSkelton] = useState(false);
  const [totalPages, setTotalPages] = useState(1);

  const handleGetBlogList = async () => {
    if (list.length === 0) setShowSkelton(true);
    try {
      let response = await getBlogListServ(payload);
      setList(response?.data?.data);
      setStatics(response?.data?.documentCount);
    } catch (error) {}
    setShowSkelton(false);
  };

  useEffect(() => {
    handleGetBlogList();
  }, [payload]);

  useEffect(() => {
    if (statics?.totalCount && payload.pageCount) {
      setTotalPages(Math.ceil(statics.totalCount / payload.pageCount));
    }
  }, [statics, payload.pageCount]);

  const staticsArr = [
    { title: "Total Blogs",    count: statics?.totalCount,    icon: STAT_ICONS[0] },
    { title: "Active Blogs",   count: statics?.activeCount,   icon: STAT_ICONS[1] },
    { title: "Inactive Blogs", count: statics?.inactiveCount, icon: STAT_ICONS[2] },
  ];

  const handleDeleteBlog = async (id) => {
    const confirmed = window.confirm("Are you sure you want to delete this blog?");
    if (confirmed) {
      try {
        let response = await deleteBlogServ(id);
        if (response?.data?.statusCode == "200") {
          toast.success(response?.data?.message);
          handleGetBlogList();
        }
      } catch (error) {
        toast.error(
          error?.response?.data?.message || "Internal Server Error"
        );
      }
    }
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setPayload({ ...payload, pageNo: newPage });
    }
  };

  return (
    <div className="bodyContainer">
      <style>{styles}</style>
      <Sidebar selectedMenu="Blog Management" selectedItem="Blogs" />

      <div className="mainContainer">
        <TopNav />

        <div className="bl-page">

          {/* ── Stat Cards ── */}
          <div className="bl-stat-grid">
            {staticsArr.map((v, i) => (
              <div className="bl-stat-card" key={i}>
                <div className="bl-stat-icon">
                  <i className={`ti ${v.icon}`} aria-hidden="true" />
                </div>
                <div>
                  <div className="bl-stat-val">{v.count ?? "—"}</div>
                  <div className="bl-stat-lbl">{v.title}</div>
                </div>
              </div>
            ))}
          </div>

          {/* ── Toolbar ── */}
          <div className="bl-toolbar">
            <div className="bl-toolbar-title">Blogs</div>
            <div className="bl-toolbar-right">
              {/* Search */}
              <div className="bl-search-wrap">
                <i className="ti ti-search bl-search-icon" aria-hidden="true" />
                <input
                  className="bl-search"
                  placeholder="Search blogs..."
                  onChange={(e) =>
                    setPayload({ ...payload, searchKey: e.target.value, pageNo: 1 })
                  }
                />
              </div>

              {/* Status filter */}
              <select
                className="bl-select"
                onChange={(e) =>
                  setPayload({ ...payload, status: e.target.value, pageNo: 1 })
                }
              >
                <option value="">All Status</option>
                <option value={true}>Active</option>
                <option value={false}>Inactive</option>
              </select>

              {/* Add button */}
              <button
                className="bl-btn-red"
                onClick={() => navigate("/add-blog")}
              >
                <i className="ti ti-plus" aria-hidden="true" />
                Add Blog
              </button>
            </div>
          </div>

          {/* ── Table ── */}
          <div className="bl-table-wrap">
            <div className="bl-table-scroll">
              <table className="bl-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Banner</th>
                    <th>Title</th>
                    <th>Tags</th>
                    <th>Rank</th>
                    <th>Status</th>
                    <th>Created At</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {showSkelton ? (
                    [...Array(9)].map((_, i) => (
                      <tr key={i}>
                        {[...Array(8)].map((__, j) => (
                          <td key={j} className="bl-skel-cell">
                            <Skeleton height={j === 1 ? 48 : 18} width={j === 1 ? 48 : "80%"} borderRadius={j === 1 ? 10 : 4} />
                          </td>
                        ))}
                      </tr>
                    ))
                  ) : list?.length === 0 ? (
                    <tr>
                      <td colSpan="8">
                        <div className="bl-empty">
                          <div className="bl-empty-icon">
                            <i className="ti ti-article-off" aria-hidden="true" />
                          </div>
                          <div className="bl-empty-text">No blogs found</div>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    list.map((v, i) => (
                      <tr key={v?._id || i}>
                        {/* Sr */}
                        <td>
                          <span className="bl-sr">
                            {(payload.pageNo - 1) * payload.pageCount + i + 1}
                          </span>
                        </td>

                        {/* Banner */}
                        <td>
                          {v?.image ? (
                            <img
                             src={getImageUrl(v.image)}
                              alt="blog banner"
                              className="bl-banner"
                            />
                          ) : (
                            <div className="bl-banner-placeholder">
                              <i className="ti ti-photo" aria-hidden="true" />
                            </div>
                          )}
                        </td>

                        {/* Title */}
                        <td>
                          <div className="bl-title-text" title={v?.title}>
                            {v?.title}
                          </div>
                        </td>

                        {/* Tags */}
                        <td>
                          {v?.tags ? (
                            <span className="bl-tag">{v.tags}</span>
                          ) : (
                            <span style={{ color: "#ccc", fontSize: "12px" }}>—</span>
                          )}
                        </td>

                        {/* Rank */}
                        <td>
                          <span className="bl-rank">{v?.rank ?? "—"}</span>
                        </td>

                        {/* Status */}
                        <td>
                          {v?.status ? (
                            <span className="bl-badge active">
                              <span className="bl-badge-dot" />
                              Active
                            </span>
                          ) : (
                            <span className="bl-badge inactive">
                              <span className="bl-badge-dot" />
                              Inactive
                            </span>
                          )}
                        </td>

                        {/* Created At */}
                        <td>
                          <span className="bl-date">
                            {moment(v?.createdAt).format("DD MMM YYYY")}
                          </span>
                        </td>

                        {/* Actions */}
                        <td>
                          <button
                            className="bl-edit-btn"
                            onClick={() => navigate("/update-blog/" + v?._id)}
                          >
                            <i className="ti ti-pencil" aria-hidden="true" />
                            Edit
                          </button>
                          <button
                            className="bl-del-btn"
                            onClick={() => handleDeleteBlog(v?._id)}
                          >
                            <i className="ti ti-trash" aria-hidden="true" />
                            Delete
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            {/* ── Pagination ── */}
            {list?.length > 0 && (
              <div className="bl-pagination">
                <div className="bl-show-row">
                  Show
                  <select
                    className="bl-select"
                    style={{ height: "34px", padding: "0 10px" }}
                    value={payload.pageCount}
                    onChange={(e) =>
                      setPayload({
                        ...payload,
                        pageCount: parseInt(e.target.value),
                        pageNo: 1,
                      })
                    }
                  >
                    {[10, 25, 50, 100].map((v) => (
                      <option key={v} value={v}>{v}</option>
                    ))}
                  </select>
                  entries
                </div>

                <div className="bl-page-btns">
                  <button
                    className="bl-pg-btn"
                    disabled={payload.pageNo === 1}
                    onClick={() => handlePageChange(payload.pageNo - 1)}
                  >
                    <i className="ti ti-chevron-left" style={{ fontSize: "13px" }} />
                  </button>

                  {[...Array(totalPages)].map((_, i) => {
                    const page = i + 1;
                    if (
                      page === 1 ||
                      page === totalPages ||
                      (page >= payload.pageNo - 1 && page <= payload.pageNo + 1)
                    ) {
                      return (
                        <button
                          key={page}
                          className={`bl-pg-btn ${payload.pageNo === page ? "active" : ""}`}
                          onClick={() => handlePageChange(page)}
                        >
                          {page}
                        </button>
                      );
                    } else if (
                      (page === payload.pageNo - 2 && page > 2) ||
                      (page === payload.pageNo + 2 && page < totalPages - 1)
                    ) {
                      return (
                        <button key={page} className="bl-pg-btn" disabled>
                          ...
                        </button>
                      );
                    }
                    return null;
                  })}

                  <button
                    className="bl-pg-btn"
                    disabled={payload.pageNo === totalPages}
                    onClick={() => handlePageChange(payload.pageNo + 1)}
                  >
                    <i className="ti ti-chevron-right" style={{ fontSize: "13px" }} />
                  </button>
                </div>
              </div>
            )}
          </div>

        </div>
      </div>
    </div>
  );
}

export default BlogList;